import { createSlice } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  // Upload + job creation flow
  isUploading: false,
  uploadProgress: 0, // 0-100
  isCreatingJob: false,
  isRedirectingToCheckout: false,
  currentStep: null, // 'presigning' | 'uploading' | 'creating' | 'redirecting' | 'done' | 'error'
  error: null,
  lastCreatedJob: null,
};

const dubbingSlice = createSlice({
  name: "dubbing",
  initialState: INITIAL_STATE,
  reducers: {
    // Saga-only action
    startDubbingRequest: () => {},

    // State mutations (dispatched by sagas)
    setUploadStep(state, action) {
      state.currentStep = action.payload;
      state.error = null;
    },
    setUploading(state, action) {
      state.isUploading = action.payload;
    },
    setUploadProgress(state, action) {
      state.uploadProgress = action.payload;
    },
    setCreatingJob(state, action) {
      state.isCreatingJob = action.payload;
    },
    setRedirectingToCheckout(state, action) {
      state.isRedirectingToCheckout = action.payload;
      state.currentStep = action.payload ? "redirecting" : state.currentStep;
    },
    startDubbingSuccess(state, action) {
      state.isUploading = false;
      state.isCreatingJob = false;
      state.currentStep = "done";
      state.uploadProgress = 100;
      state.lastCreatedJob = action.payload;
      state.error = null;
    },
    startDubbingFailure(state, action) {
      state.isUploading = false;
      state.isCreatingJob = false;
      state.currentStep = "error";
      state.error = action.payload;
    },
    resetDubbingState(state) {
      Object.assign(state, INITIAL_STATE);
    },
  },
});

export default dubbingSlice.actions;

export const {
  startDubbingRequest,
  setUploadStep,
  setUploading,
  setUploadProgress,
  setCreatingJob,
  setRedirectingToCheckout,
  startDubbingSuccess,
  startDubbingFailure,
  resetDubbingState,
} = dubbingSlice.actions;

export const { reducer } = dubbingSlice;

// Selectors
export const selectDubbingState = (state) => state.dubbing;
export const selectIsUploading = (state) => state.dubbing.isUploading;
export const selectCurrentStep = (state) => state.dubbing.currentStep;
export const selectUploadProgress = (state) => state.dubbing.uploadProgress;
export const selectDubbingError = (state) => state.dubbing.error;
export const selectLastCreatedJob = (state) => state.dubbing.lastCreatedJob;
